module.exports = new __parcel__URL__("design-desk.4e655d74.jpeg").toString();